// hi-ui imports image assets as `import logo from './logo.svg'` and passes the
// result straight to <img src>. Webpack (the UMD/customer build) resolves such
// imports to a URL string, but some bundlers — notably Next.js / Turbopack —
// resolve them to a static-import object (`{ src, height, width, ... }`), which
// renders as "[object Object]". Normalising here lets the same component code
// work under either bundler, keeping hi-ui portable to Next consumers without
// changing the customer UMD behaviour (there the input is already a string).
export type AssetImport = string | { src: string };

export const assetSrc = (asset: AssetImport): string =>
  typeof asset === 'string' ? asset : asset.src;
